import { HttpParams } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { BaseResourceService } from 'eddydata-lib';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class DemonstrativoAuxiliarDeGastosService extends BaseResourceService<any> {

  constructor(protected injector: Injector) {
    super('contabil-relatorio', injector);
  }

  public obterDemonstrativoAuxiliarDeGastos(exercicio: number, ppa: number, mes: number, quadrimestre: 4 | 8 | 12, acumulado: boolean, dtInicio?: string, dtFinal?: string): Observable<number> {
    let parametros: {} = {
      exercicio,
      ppa,
      mes,
      quadrimestre,
      acumulado
    };
    if (dtInicio && dtFinal) {
      parametros = { ...parametros, dtInicio, dtFinal };
    }
    const params = new HttpParams().appendAll(parametros);

    const options = { ...this.httpOptions(), params };
    return this.http.get<number>(`${this.login.cidade.id}/${this.api}/demonstrativo-auxiliar-de-gastos`, options)
      .pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }
}
